/* Minimal catalog filters interaction. Filtering itself is performed by Shopify via standard GET form. */
(()=>{'use strict';
 const toggle=document.querySelector('[data-ov82-filter-toggle]');
 const panel=document.querySelector('[data-ov82-filter-panel]');
 if(!toggle||!panel)return;
 toggle.addEventListener('click',()=>{
   const open=panel.hidden;
   panel.hidden=!open;
   toggle.setAttribute('aria-expanded',String(open));
   if(open){panel.querySelector('summary,select,input,button')?.focus({preventScroll:true});}
 });
 if(panel.querySelector('input[type=checkbox]:checked')){
   panel.hidden=false;toggle.setAttribute('aria-expanded','true');
 }
})();

